var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _c("i", { staticClass: "fa fa-gear" }),
              _vm._v(" "),
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t("productQualityTests.archiveModal.title") + ": "
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.dismiss.apply(null, arguments)
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("productQualityTests.product.model.archiveReason")
                  ) +
                  "\n        "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reason,
                    expression: "reason"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: _vm.reason },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.reason = $event.target.value
                  }
                }
              }),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("productQualityTests.product.model.archiveRisk")
                  ) +
                  "\n        "
              ),
              _c("v-select", {
                attrs: {
                  options: _vm.riskOptions,
                  label: "name",
                  clearable: false
                },
                model: {
                  value: _vm.riskOption,
                  callback: function($$v) {
                    _vm.riskOption = $$v
                  },
                  expression: "riskOption"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              { staticClass: "btn btn-secondary", on: { click: _vm.dismiss } },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("btnCancel")) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-primary", on: { click: _vm.archive } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("productQualityTests.archiveModal.archive")) +
                    "\n        "
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }